var l = /* @__PURE__ */ ((L) => (L.SINGLE_LINE = "single-line", L.MULTI_LINE = "multi-line", L.MULTI_LEVEL = "multi-level", L))(l || {});
export {
  l as L
};
